import { validateCitySlug } from '@utils';
import { useContext, useMemo } from 'react';
import { codeToSlugNameMap } from '../../../../utils/categoryNameMappings';
import { CategoryRecommendationsContext } from './CategoryRecommendationsProvider';
import { MCVRM_SOURCE_CONTENT } from './types';

export const getSeeAllUrlForSelectedCategory = (
	storefrontVendor: Vendor.Raw | null,
	selectedCategoryCode: Category.CategoryCode | null,
	searchPageLocation?: Redux.SearchPageLocation | null,
): string => {
	if (!storefrontVendor) return '';

	const categoryCode = selectedCategoryCode;
	if (!categoryCode) return '';

	const city =
		searchPageLocation?.city || storefrontVendor.location?.address?.city;
	const state =
		searchPageLocation?.stateCode || storefrontVendor.location?.address?.state;
	if (!city || !state) return '';

	const selectedCategorySlug =
		codeToSlugNameMap[categoryCode as keyof typeof codeToSlugNameMap]?.href;
	if (!selectedCategorySlug) return '';

	return `/marketplace/${selectedCategorySlug}-${validateCitySlug(city)}-${state}?sort=featured`.toLowerCase();
};

export const useCommonTrackingProperties = () => {
	const { selectedCategoryVendors, selectedCategoryCode } = useContext(
		CategoryRecommendationsContext,
	);

	return useMemo(
		() => ({
			pagePosition: 'middle',
			sourceContent: MCVRM_SOURCE_CONTENT,
			sourcePage: 'unpaid storefront',
			sourceChannel: 'internal',
			sourceFormula: 'pvrec cross category ros',
			widgetName: 'McVrmLiteWidget',
			vendorCategory: selectedCategoryCode,
			vendorCount: selectedCategoryVendors.length,
		}),
		[selectedCategoryCode, selectedCategoryVendors.length],
	);
};
